import { useTranslation } from 'react-i18next'

const LANGUAGES = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'pt', label: 'PT' },
] as const

export default function LanguageSelector() {
  const { i18n } = useTranslation()
  const current = i18n.resolvedLanguage ?? i18n.language

  return (
    <div className="flex items-center gap-1 text-xs">
      {LANGUAGES.map((lang, idx) => (
        <span key={lang.code} className="flex items-center">
          <button
            type="button"
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`px-1 uppercase tracking-wider transition-colors ${
              current === lang.code
                ? 'text-white font-medium'
                : 'text-white/50 hover:text-white/80'
            }`}
            aria-current={current === lang.code ? 'true' : undefined}
            aria-label={lang.label}
          >
            {lang.label}
          </button>
          {idx < LANGUAGES.length - 1 && <span className="text-white/30">·</span>}
        </span>
      ))}
    </div>
  )
}
